export const sanitizeBrandId = (input: string): string => {
  // Send all local brands to the same brand settings
  if (input.startsWith("192")) {
    return "192_168_1_168";
  }

  return input.replace(/[.$[\]#/]/g, "_");
};
